import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { updateActiveTab } from "../features/featuresSlice";
import Header from "../components/Header";
import StoreSearch from "../components/store/StoreSearch";
import SurveyList from "../components/surveys/SurveyList";

export default function Dashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.features.auth);
  const activeTab = useSelector((state) => state.features.activeTab);
  
  // Toggle state
  const [isToggling, setIsToggling] = useState(false);
  
  // User menu state
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  useEffect(() => {
    if (!auth) {
      navigate("/login");
    }
  }, [auth, navigate]);

  // Restore active tab from localStorage on component mount
  useEffect(() => {
    const savedTab = localStorage.getItem('adminActiveTab');
    if (savedTab && savedTab !== activeTab) {
      dispatch(updateActiveTab(savedTab));
    }
  }, [dispatch, activeTab]);

  useEffect(() => {
    const handler = (e) => {
      if (
        isUserMenuOpen &&
        userMenuRef.current &&
        !userMenuRef.current.contains(e.target)
      ) {
        setIsUserMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [isUserMenuOpen]);

  const handleTabChange = (tab) => {
    if (tab === activeTab) return;
    
    setIsToggling(true);
    // Simulate loading time for smooth transition
    setTimeout(() => {
      dispatch(updateActiveTab(tab));
      setIsToggling(false);
    }, 300);
  };

  return (
    <div className="min-h-screen bg-[#F7F8FA] text-[#000000]">
      <Header
        isOpen={isUserMenuOpen}
        onToggle={() => setIsUserMenuOpen((v) => !v)}
        menuRef={userMenuRef}
      />

      <main className="p-8 pt-6">
        {/* Toggle Button */}
        <div className="mb-6 flex justify-center">
          <div className="bg-gray-200 rounded-3xl shadow-sm p-1 inline-flex">
            <button
              onClick={() => handleTabChange("stores")}
              className={`px-6 py-2 rounded-3xl font-medium transition-all duration-200 ${
                activeTab === "stores"
                  ? "bg-[#2962FF] text-white shadow-sm"
                  : "text-gray-600 hover:text-gray-800"
              }`}
            >
              Stores
            </button>
            <button
              onClick={() => handleTabChange("surveys")}
              className={`px-6 py-2 rounded-3xl font-medium transition-all duration-200 ${
                activeTab === "surveys"
                  ? "bg-[#2962FF] text-white shadow-sm"
                  : "text-gray-600 hover:text-gray-800"
              }`}
            >
              Surveys
            </button>
          </div>
        </div>

        {/* Content Area */}
        {isToggling ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#2962FF]"></div>
          </div>
        ) : (
          <div className="transition-opacity duration-300">
            {activeTab === "stores" ? <StoreSearch /> : <SurveyList />}
          </div>
        )}
      </main>
    </div>
  );
}
